import { SocialProvider } from '@/store/api/interfaces';
import {useApi} from '@composables/useApi';
import {useAuthApi} from "@store/api/authApi";
import isInTelegram from "@/utils/isInTelegram";
import { openLink } from "@tma.js/sdk-vue";

export function useSocialProviders() {
	const authApi = useAuthApi();

	const auth = (provider: SocialProvider) => {
		window.location.href = `${import.meta.env.VITE_API_BASE}/auth/${provider}/redirect`;
	};

	const connect = async (provider: SocialProvider) => {
		// Open window synchronously before async call to avoid iOS Safari popup blocker
		const popup = isInTelegram() ? null : window.open('about:blank', 'popup', 'width=600,height=700');

		try {
			const response = await useApi(`/connect/${provider}/prepare`, {
				method: "POST",
				headers: authApi.methods.getAuthHeaders(),
			});

			if (isInTelegram()) {
				openLink.ifAvailable(response.url, {
					tryInstantView: false
				});
			} else if (popup) {
				popup.location.href = response.url;
			}

			return response;
		} catch (error) {
			if (popup) popup.close();
			throw error;
		}
	};

	return {
		auth,
		connect
	}
}
